import React from "react";
import styled from "styled-components";
import { arrayOf, func, string } from "prop-types";

import TestDriveType from "./TestDriveType";

import { desktop } from "../shared/utils";
import { testDriveType } from "@types";

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${desktop`
    padding: 0.75rem 0;
  `}
`;

const TestDriveTypesList = ({ testDriveTypes, setTypeFilter, affiliation }) => (
  <Wrapper>
    {(testDriveTypes || [])
      .filter(testDriveType => testDriveType.status)
      .map(testDriveType => (
        <TestDriveType
          key={testDriveType.id}
          testDriveType={testDriveType}
          setTypeFilter={setTypeFilter}
          affiliation={affiliation}
        />
      ))}
  </Wrapper>
);

TestDriveTypesList.propTypes = {
  testDriveTypes: arrayOf(testDriveType),
  setTypeFilter: func,
  affiliation: string,
};

export default TestDriveTypesList;
